<div class="signup-page-wrapper">
  <div class="signup-container">
    <div class="signup-header">
      <div class="logo-section">
        <img src="assets/deeproots-logo.jpg" alt="App Logo" class="app-logo" />
      </div>
      <h1 class="signup-title">
        Small Business Resource Provider Request to Join
      </h1>
      <p class="signup-subtitle">Register your business to connect with us</p>
    </div>

    <!-- Service Region Info Banner -->
    <!-- @if (!showSuccessMessage) {
      <div class="info-banner">
        <div class="info-icon">
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="16" x2="12" y2="12" />
            <line x1="12" y1="8" x2="12.01" y2="8" />
          </svg>
        </div>
        <p>
          <strong>Service Region:</strong> Please specify the geographic area where your organization provides services. City and postal code are optional—only provide them if your services are limited to a specific location.
        </p>
      </div>

    } -->

    <!-- Login Redirect Message -->
    @if (isLoginRedirect) {
      <div class="info-banner">
        <div class="info-icon">
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              d="M12 2.5c.5 0 1 .27 1.26.8l9.1 15.76c.51.88-.13 1.94-1.13 1.94H2.77c-1 0-1.64-1.06-1.13-1.94l9.1-15.76c.25-.43.75-.8 1.26-.8zm0 5.2a1 1 0 0 0-1 1v5.2a1 1 0 0 0 2 0V8.7a1 1 0 0 0-1-1zm0 10.2a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4z"
            />
          </svg>
        </div>
        <div class="info-content">
          <h4>Action required: Complete your registration</h4>
          <p>
            It looks like you haven't signed up yet. Please complete this form
            to join us. ACC Admin will review your application and connect with
            you.
          </p>
        </div>
      </div>
    }

    <!-- Success Message -->
    @if (showSuccessMessage) {
      <div class="success-message">
        <div class="success-icon">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <polyline points="22,4 12,14.01 9,11.01" />
          </svg>
        </div>
        <div class="success-content">
          <h3>Success!</h3>
          <p>
            Application submitted successfully! We will review your request and
            contact you soon.
          </p>
        </div>
      </div>
    }

    <form class="signup-form" [class.form-hidden]="showSuccessMessage">
      <!-- ORGANIZATION NAME -->
      <div class="form-group">
        <label for="organizationName" class="form-label"
          >Organization Name <span class="required">*</span></label
        >
        <div class="input-wrapper">
          <input
            id="organizationName"
            name="organizationName"
            type="text"
            class="form-input"
            [(ngModel)]="formData.organizationName"
            required
            minlength="2"
            maxlength="100"
            placeholder="Enter your organization name"
            (blur)="onBlur('organizationName')"
            [class.error]="
              getFieldError('organizationName', 'Organization Name')
            "
          />
          <div class="input-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 640 640"
              width="20"
              height="20"
              fill="currentColor"
            >
              <path
                d="M335.9 84.2C326.1 78.6 314 78.6 304.1 84.2L80.1 212.2C67.5 219.4 61.3 234.2 65 248.2C68.7 262.2 81.5 272 96 272L128 272L128 480L128 480L76.8 518.4C68.7 524.4 64 533.9 64 544C64 561.7 78.3 576 96 576L544 576C561.7 576 576 561.7 576 544C576 533.9 571.3 524.4 563.2 518.4L512 480L512 272L544 272C558.5 272 571.2 262.2 574.9 248.2C578.6 234.2 572.4 219.4 559.8 212.2L335.8 84.2zM464 272L464 480L400 480L400 272L464 272zM352 272L352 480L288 480L288 272L352 272zM240 272L240 480L176 480L176 272L240 272zM320 160C337.7 160 352 174.3 352 192C352 209.7 337.7 224 320 224C302.3 224 288 209.7 288 192C288 174.3 302.3 160 320 160z"
              />
            </svg>
          </div>
        </div>
        @if (getFieldError("organizationName", "Organization Name")) {
          <div class="error-message">
            {{ getFieldError("organizationName", "Organization Name") }}
          </div>
        }
      </div>

      <!-- ORGANIZATION TYPE -->
      <div class="form-group">
        <label for="orgType" class="form-label">
          Organization Type <span class="required">*</span>
        </label>
        <div class="input-wrapper">
          <select
            id="orgType"
            name="orgType"
            class="form-input form-select"
            [(ngModel)]="formData.orgType"
            required
            (ngModelChange)="onOrgTypeChange($event)"
            (blur)="onBlur('orgType')"
            [class.error]="getFieldError('orgType', 'Organization Type')"
          >
            <option [ngValue]="null" disabled selected>
              Select organization type
            </option>
            @for (orgType of orgTypes; track orgType.value) {
              <option [value]="orgType.value">
                {{ orgType.label }}
              </option>
            }
          </select>
          <div class="input-icon">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
              <polyline points="9 22 9 12 15 12 15 22" />
            </svg>
          </div>
          <div class="select-arrow">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
              <path d="M7 10l5 5 5-5z" />
            </svg>
          </div>
        </div>
        @if (getFieldError("orgType", "Organization Type")) {
          <div class="error-message">
            {{ getFieldError("orgType", "Organization Type") }}
          </div>
        }
      </div>

      <!-- OTHER ORG TYPE -->
      @if (isOtherOrgType()) {
        <div class="form-group">
          <label for="orgTypeDesc" class="form-label"
            >Please Specify Organization Type</label
          >
          <div class="input-wrapper">
            <input
              id="orgTypeDesc"
              name="orgTypeDesc"
              type="text"
              class="form-input"
              [(ngModel)]="formData.orgTypeDesc"
              required
              maxlength="100"
              placeholder="Enter your organization type"
              (blur)="onBlur('orgTypeDesc')"
              [class.error]="
                getFieldError('orgTypeDesc', 'Organization Type Description')
              "
            />
            <div class="input-icon">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
                />
                <path
                  d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
                />
              </svg>
            </div>
          </div>
          @if (getFieldError("orgTypeDesc", "Organization Type Description")) {
            <div class="error-message">
              {{
                getFieldError("orgTypeDesc", "Organization Type Description")
              }}
            </div>
          }
        </div>
      }

      <!-- EMAIL -->
      <div class="form-group">
        <label for="contactEmail" class="form-label"
          >Contact Email <span class="required">*</span></label
        >
        <div class="input-wrapper">
          <input
            id="contactEmail"
            name="contactEmail"
            type="email"
            class="form-input"
            [(ngModel)]="formData.contactEmail"
            placeholder="your@email.com"
            required
            email
            maxlength="100"
            (blur)="onBlur('contactEmail')"
            [class.error]="getFieldError('contactEmail', 'Contact Email')"
          />
          <div class="input-icon">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <rect width="20" height="16" x="2" y="4" rx="2" />
              <path d="m22 7-10 5L2 7" />
            </svg>
          </div>
        </div>
        @if (getFieldError("contactEmail", "Contact Email")) {
          <div class="error-message">
            {{ getFieldError("contactEmail", "Contact Email") }}
          </div>
        }
      </div>

      <!-- WEBSITE -->
      <div class="form-group">
        <label for="website" class="form-label"
          >Website <span class="optional">(Optional)</span></label
        >
        <div class="input-wrapper">
          <input
            id="website"
            name="website"
            type="text"
            class="form-input"
            [(ngModel)]="formData.website"
            placeholder="https://example.com"
            (blur)="onBlur('website')"
            [class.error]="getFieldError('website', 'Website')"
          />
          <div class="input-icon">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <circle cx="12" cy="12" r="10" />
              <line x1="2" y1="12" x2="22" y2="12" />
              <path
                d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
              />
            </svg>
          </div>
        </div>
        @if (getFieldError("website", "Website")) {
          <div class="error-message">
            {{ getFieldError("website", "Website") }}
          </div>
        }
      </div>

      <!-- IT SUPPORT -->
      <div class="form-group radio-group">
        <div class="form-label">
          Do you have an IT support team? <span class="required">*</span>
        </div>
        <div class="radio-options">
          <div class="radio-option">
            <input
              type="radio"
              id="yes"
              name="hasItSupport"
              [value]="true"
              [(ngModel)]="formData.hasItSupport"
              class="form-radio"
              (change)="onBlur('hasItSupport')"
            />
            <label for="yes">Yes</label>
          </div>
          <div class="radio-option">
            <input
              type="radio"
              id="no"
              name="hasItSupport"
              [value]="false"
              [(ngModel)]="formData.hasItSupport"
              class="form-radio"
              (change)="onBlur('hasItSupport')"
            />
            <label for="no">No</label>
          </div>
        </div>
        @if (getFieldError("hasItSupport", "IT Support")) {
          <div class="error-message">
            {{ getFieldError("hasItSupport", "IT Support") }}
          </div>
        }
      </div>

      <!-- Service Region Section Header -->
      <div class="section-header">
        <h3>Service Region</h3>
        <p>Add all geographic areas where you provide services</p>
      </div>

      <!-- STATES -->
      <div class="form-group">
        <label for="state" class="form-label"
          >States <span class="required">*</span></label
        >
        <div class="input-wrapper">
          <app-multiselect-filter
            id="states"
            class="full-width-filter"
            [options]="statesList"
            [placeholder]="'Select States'"
            [optionKey]="'name'"
            [valueKey]="'id'"
            [selectedValues]="selectedStates"
            (apply)="addStates($event)"
          ></app-multiselect-filter>
        </div>
      </div>

      <!-- COUNTIES -->
      <div class="form-group">
        <label for="county" class="form-label"
          >Counties <span class="required">*</span></label
        >
        <div class="input-wrapper">
          <app-multiselect-filter
            id="counties"
            class="full-width-filter"
            [options]="countiesList"
            [placeholder]="'Select Counties'"
            [optionKey]="'name'"
            [valueKey]="'id'"
            [isDisabled]="selectedStates.length === 0"
            [selectedValues]="selectedCounties"
            (apply)="addCounties($event)"
          ></app-multiselect-filter>
        </div>
      </div>

      <!-- CITIES -->
      <div class="form-group">
        <label for="city" class="form-label"
          >Cities <span class="optional">(Optional)</span></label
        >
        <div class="input-wrapper">
          <app-multiselect-filter
            id="cities"
            class="full-width-filter"
            [options]="citiesList"
            [placeholder]="'Select Cities'"
            [optionKey]="'name'"
            [valueKey]="'id'"
            [isDisabled]="selectedStates.length === 0"
            [selectedValues]="selectedCities"
            (apply)="addCity($event)"
          ></app-multiselect-filter>
        </div>
      </div>

      <!-- ZIP -->
      <div class="form-group">
        <label for="postalCode" class="form-label"
          >Postal Codes <span class="optional">(Optional)</span></label
        >
        <div class="input-wrapper">
          <app-multiselect-filter
            id="zipCodes"
            class="full-width-filter"
            [options]="zipCodesList"
            [placeholder]="'Select Zip Codes'"
            [optionKey]="'code'"
            [valueKey]="'id'"
            [isDisabled]="selectedCities.length === 0"
            [selectedValues]="selectedZipCodes"
            (apply)="addZipCode($event)"
          ></app-multiselect-filter>
        </div>
      </div>

      <!-- Separator -->
      <div class="form-separator"></div>

      <!-- NOTES -->
      <div class="form-group">
        <label for="applicationNotes" class="form-label"
          >Additional Notes <span class="optional">(Optional)</span></label
        >
        <div class="textarea-wrapper">
          <textarea
            id="applicationNotes"
            class="form-textarea"
            name="applicationNotes"
            [(ngModel)]="formData.applicationNotes"
            placeholder="Any additional information you'd like to share about your organization or application..."
            rows="4"
            maxlength="500"
            (blur)="onBlur('applicationNotes')"
            [class.error]="
              getFieldError('applicationNotes', 'Additional Notes')
            "
          ></textarea>
          <div class="textarea-icon">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
              />
            </svg>
          </div>
          <div class="char-counter">
            {{ formData.applicationNotes.length || 0 }}/500
          </div>
        </div>
        @if (getFieldError("applicationNotes", "Additional Notes")) {
          <div class="error-message">
            {{ getFieldError("applicationNotes", "Additional Notes") }}
          </div>
        }
      </div>

      <!-- CAPTCHA -->
      <div class="form-group captcha-wrapper">
        <app-google-recaptcha
          (recaptchaToken)="onCaptchaResolved($event)"
        ></app-google-recaptcha>
      </div>

      <!-- ERROR MESSAGE -->
      @if (errorMessage) {
        <div class="error-banner">
          <div class="error-icon">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <circle cx="12" cy="12" r="10" />
              <line x1="15" y1="9" x2="9" y2="15" />
              <line x1="9" y1="9" x2="15" y2="15" />
            </svg>
          </div>
          <p>{{ errorMessage }}</p>
        </div>
      }

      <!-- SUBMIT -->
      <button
        (click)="onSubmit()"
        class="submit-button"
        [disabled]="isSubmitting || !isFormValid()"
      >
        @if (!isSubmitting) {
          <span>Submit Application</span>
        }
        @if (isSubmitting) {
          <span class="loading-text">
            <svg class="spinner" width="20" height="20" viewBox="0 0 24 24">
              <circle
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="4"
                fill="none"
                stroke-dasharray="32"
                stroke-dashoffset="32"
              >
                <animate
                  attributeName="stroke-dashoffset"
                  values="32;0"
                  dur="1.5s"
                  repeatCount="indefinite"
                />
              </circle>
            </svg>
            Submitting...
          </span>
        }
      </button>
    </form>

    <div class="signup-footer">
      <p>
        Already have an account?
        <a routerLink="/login" class="login-link">Sign in here</a>
      </p>
    </div>
  </div>
</div>
